import {useState, useEffect} from 'react'
import {useCustomMutation} from '@salesforce/commerce-sdk-react'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import useIsMobile from '../../../hooks/use-is-mobile'
import usedDeviceDetection from '../../../hooks/use-device-detection'

const SOURCE = {
    DESKTOPWEB: 'DESKTOPWEB',
    MOBILEWEB: 'MOBILEWEB'
}

const BRAND_ID = 'garage'

const notifyMe = () => {
    const isMobile = useIsMobile();
    const [isLoading, setIsLoading] = useState(false)
    const [source, setSource] = useState(SOURCE.DESKTOPWEB);
    const [sku, setSku] = useState(null);
    const [email, setEmail] = useState('')
    const device = usedDeviceDetection()

    useEffect(() => {
        setSource(isMobile ? SOURCE.MOBILEWEB : SOURCE.DESKTOPWEB);
    }, [isMobile]);

    const mutation = useCustomMutation({
        options: {
            method: 'POST',
            body: JSON.stringify({
                brandId: BRAND_ID,
                source: source,
                sku: sku,
                email: email,
                device: device
            }),
            customApiPathParameters: {
                apiVersion: 'v1',
                endpointPath: '/notify-me',
                apiName: 'notify-me'
            }
        }
    })

    const submitNotifyMe = async ({formData, shouldFetch = true}) => {
        if (!shouldFetch) return

        let data

        setIsLoading(true)

        try {
            let form = JSON.parse(formData)

            setEmail(form?.notifyMeEmail)
            setSku(form?.notifyMeSKU)

            data = await mutation.mutateAsync({
                method: 'POST',
                options: {
                    body: JSON.stringify({
                        brandId: BRAND_ID,
                        source: source,
                        sku: sku,
                        email: email
                    })
                }
            })
        } catch (error) {
            logger.error('Error submitting notify me', {
                namespace: 'notify-me',
                additionalProperties: {error: error.message, stack: error.stack}
            })
        } finally {
            setIsLoading(false)
        }

        return data
    }

    return {
        isLoading,
        submitNotifyMe
    }
}

export {notifyMe}
